<template>
  <el-dialog :title="ruleForm.siteId?$t('COMMON_EDIT'):$t('COMMON_ADD_ITEM')"
             visible
             width="40%"
             @close="onCancel">

    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-position="left"
             label-width="140px"
             class="demo-ruleForm">

      <el-form-item :label="$t('SITE_TABLE_HEADER_SITE_NAME')"
                    prop="siteName">
        <el-input v-model="ruleForm.siteName"
                  maxlength="100"
                  :placeholder="$t('SITE_TABLE_HEADER_SITE_NAME')"></el-input>
      </el-form-item>
      <!--项目合伙人-->
      <el-form-item :label="$t('SITE_LABEL_SITE_OWNER')"
                    prop="siteOwner"> 
                    <!-- 不明觉厉，没敢乱删 -->
      <!-- <el-form-item :label="$t('SITE_LABEL_SITE_OWNER')"
                    prop="siteOwner"
                    :rules="ruleForm.siteId? []: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }]"
      > -->
        <select-ad ref="ownertAdd"
                   class="wl-m-select"
                   v-model="ruleForm.siteOwner"
                   :collapseTags="false"
                   :showAdd="false"
                   :filter="adFilter"
                   :onChanage="onsiteOwnerChange"
                   :api="selectFromAD"></select-ad>
      </el-form-item>
      <!--项目管理员-->
      <!-- <el-form-item :label="$t('SITE_LABEL_SITE_MANGER')"
                    prop="siteManager"
                    :rules="ruleForm.siteId? []: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }]"
      > -->
      <el-form-item :label="$t('SITE_LABEL_SITE_MANGER')"
                    prop="siteManager">
        <select-ad ref="mangerAdd"
                   class="wl-m-select"
                   v-model="ruleForm.siteManager"
                   :collapseTags="false"
                   :showAdd="false"
                   :filter="adFilter"
                   :onChanage="onsiteMangerChange"
                   :api="selectFromAD"></select-ad>

      </el-form-item>
      <!--站点管理员-->
      <el-form-item :label="$t('SITE_TABLE_HEADER_SITE_ADMIN')"
                    prop="userList">
        <select-ad ref="selectAdd"
                   class="wl-m-select"
                   v-model="ruleForm.userList"
                   :collapseTags="false"
                   :showAdd="false"
                   :filter="adFilter"
                   :onChanage="onsiteAdminChange"
                   :api="selectFromAD"></select-ad>

      </el-form-item>

      <el-form-item :label="$t('SITE_TABLE_HEADER_ENGAGEMENT_CODE')" prop="engagementMasterCode">
        <el-input v-model="ruleForm.engagementMasterCode"
                  maxlength="50"
                  :placeholder="$t('SITE_TABLE_HEADER_ENGAGEMENT_CODE')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('form_code_type')" prop="codeType">
        <el-select
          v-model="ruleForm.codeType"
          :placeholder="$t('form_code_type')">
          <el-option
            v-for="(v, k) in codeTypeOptions"
            :key="k"
            :value="v.value"
            :label="v.label"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="siteFlag"  :label-width="i18N==='en'?'410px':'300px'">
        <template slot="label">
          {{$t('SITE_ADD_NEW_ITEM_LLP_TIP')}}
        </template>

        <el-switch
                :disabled="!!ruleForm.siteId"
                v-model="ruleForm.siteFlag"
                @change="changeSiteFlag($event,1)"
                active-color="#3879eb"
                inactive-color="#a9acaf">
        </el-switch>
      </el-form-item>
      <el-form-item prop="siteFlag2" :label="$t('SITE_ADD_NEW_ITEM_OVERSEA')"  :label-width="i18N==='en'?'410px':'300px'">
        <el-switch
                :disabled="!!ruleForm.siteId"
                v-model="ruleForm.siteFlag2"
                @change="changeSiteFlag($event,2)"
                active-color="#3879eb"
                inactive-color="#a9acaf">
        </el-switch>
      </el-form-item>
      <el-form-item prop="downloadAble" :label-width="i18N==='en'?'410px':'300px'">
        <template slot="label">
          {{ $t('DOWNLOAD_AUTH')}}
        </template>

        <el-switch
                v-model="ruleForm.downloadAble"
                @change="authChange"
                active-color="#3879eb"
                inactive-color="#a9acaf">
        </el-switch>
      </el-form-item>
    </el-form>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="cancel-btn">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 @click="onConfirm"
                 :loading="editLoading"
                 class="wl-green">{{$t('btn_save')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
    import SelectAd from '@/components/common/selectAd'
    import API from '@/api'
    import * as _ from 'lodash'
    import { UserInput } from '@/utils'

    export default {
        data() {
            return {
                ruleForm: {
                    siteName: '',
                    userList: [],
                    siteOwner: '',
                    siteManager: '',
                    siteId: '',
                    siteFlag: false,
                    siteFlag2: true,
                    siteType: false,
                    downloadAble: false,
                    engagementMasterCode: '',
                    codeType: '',
                    memberList: [],
                  },
                codeTypeOptions: [
                  {
                    label: this.$t('site_code_type_long_master'),
                    value: "0"
                  },
                  {
                    label: this.$t('site_code_type_long_sub'),
                    value: "1"
                  },
                  {
                    label: this.$t('site_code_type_long_opp'),
                    value: "2"
                  },
                  {
                    label: this.$t('site_code_type_long_bd'),
                    value: "3"
                  }
                ]
            }
        },
        computed: {
            rules() {
                const rules = {
                    siteName: [
                        { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                        {
                            pattern: UserInput.reg,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_01')
                        }
                    ],
                    userList: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }],
                    siteManager: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }],
                    memberList: [{ required: false, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }],
                    siteOwner: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }],
                    siteFlag: [{ required: true }],
                    siteFlag2: [{ required: true }],
                    downloadAble: [{ required: true }],
                    engagementMasterCode: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED')}],
                    codeType: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED')},],
                }
                return rules
            },
            i18N(){
                return this.$i18n.locale;
            }
        },
        mounted() {
            if (!_.isEmpty(this.defaultValue)) {
                this.ruleForm.siteId = this.defaultValue.siteId //修改的时候会有id

                this.ruleForm.siteName = this.defaultValue.siteName

                this.ruleForm.userList = _.map(this.defaultValue.userList, v => v.userAccount)

                this.ruleForm.siteOwner = this.defaultValue.siteOwner.userAccount

                this.ruleForm.siteManager = this.defaultValue.siteManager.userAccount

                this.ruleForm.siteType = this.defaultValue.siteType === '1'

                this.ruleForm.siteFlag = this.defaultValue.siteFlag === '1'

                this.ruleForm.siteFlag2 = this.defaultValue.siteFlag !== '1'

                this.ruleForm.downloadAble = this.defaultValue.downloadAble

                this.ruleForm.engagementMasterCode = this.defaultValue.engagementMasterCode

                this.ruleForm.codeType = this.defaultValue.codeType

                this.ruleForm.memberList = _.map(this.defaultValue.memberList, v => v.userAccount)
            }
        },
        methods: {
          changeSiteFlag(e,value){
            if(value === 1){
              if(e){
                this.ruleForm.siteFlag2 = false
              } else {
                this.ruleForm.siteFlag2 = true
              }
            } else {
              if(e){
                this.ruleForm.siteFlag = false
              } else {
                this.ruleForm.siteFlag = true
              }
            }
          },
            async onConfirm() {
              if (!this.ruleForm.siteId) {
                await this.$confirm(this.$t('site_add_notice'), this.$t('COMMON_TIP'), {
                  confirmButtonText: this.$t('btn_confirm'),
                  cancelButtonText: this.$t('btn_cancel'),
                  type: 'warning'
                })
              }

              this.$refs.ruleForm.validate(validate => {
                  if (validate) {
                      const chosenVals = this.$refs.selectAdd.getOptionValue()
                      // const chosenMemberVals = this.$refs.selectMember.getOptionValue()
                      const chosenOwner = this.$refs.ownertAdd.getOptionValue()
                      const chosenManger = this.$refs.mangerAdd.getOptionValue()

                      this.onAddOrEdit({
                          siteId: this.ruleForm.siteId,
                          siteName: this.ruleForm.siteName,
                          userList: chosenVals,
                          siteOwner: chosenOwner[0],
                          siteManager: chosenManger[0],
                          siteFlag: this.ruleForm.siteFlag ? '1' : '0',
                          siteType: this.ruleForm.siteType ? '1' : '0',
                          downloadAble:this.ruleForm.downloadAble? 1: 0,
                          engagementMasterCode: this.ruleForm.engagementMasterCode,
                          codeType: this.ruleForm.codeType,
                          // memberList: chosenMemberVals
                      })
                  }
              })
            },
            onsiteAdminChange(v) {
                this.ruleForm.userList = v
                this.$refs.ruleForm.validateField('userList')
            },
          onsiteMangerChange(v) {
                this.ruleForm.siteManager = v
                this.$refs.ruleForm.validateField('siteManager')
            },
            onsiteOwnerChange(v) {
                this.ruleForm.siteOwner = v
                this.$refs.ruleForm.validateField('siteOwner')
            },
            adFilter: v => Object.assign({}, v, {
                label: v.userName + '  (' + v.profitCenter + ')',
                value: v.userAccount
            }),
            topicList: () => API.pbc.topicList(),
            selectFromAD: params => API.system.adList(params),
            authChange(data){
              if(data) {
                this.$confirm(this.$t('OPEN_LITE_AUTHORITY_WARNING'), this.$t('COMMON_TIP'), {
                  confirmButtonText: this.$t('btn_confirm'),
                  cancelButtonText: this.$t('btn_cancel'),
                  type: 'warning'
                }).then(() => {

                }).catch(() => {
                  this.ruleForm.downloadAble = !this.ruleForm.downloadAble
                });
              }
            },
        },
        components: {
            SelectAd
        },
        props: {
            onAddOrEdit: Function,
            onCancel: Function,
            defaultValue: Object,
            editLoading: Boolean
        }
    }
</script>
<style scoped>
  .wl-m-select {
    width: 100%;
  }
</style>
